import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/llm-provider-tokens'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'llm_provider_tokens_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'llm_provider_tokens_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'llm_provider_tokens_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
